import React, { Component } from 'react';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import { Steps, Layout, notification } from 'antd/lib';
import { withApollo, graphql, compose } from 'react-apollo';
import * as Icons from '@ant-design/icons';

import * as actionsContraventores from '../../../actions/contraventores';
import * as actionsMain from '../../../actions/main';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import FormDireccionReal from './FormDireccionReal';
import insertContraventor from '../../../graphql/mutations/contravenciones/insertContraventor.graphql';
import agregarContraventor from '../../../graphql/mutations/contravenciones/agregarContraventor.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertContraventor, {
    name: 'insertContraventor',
  }),
  graphql(agregarContraventor, {
    name: 'agregarContraventor',
  })
)
class SumarContraventor extends Component {
  state = {
    persona: {},
    step: 0,
  };

  guardarPersona = persona => {
    //Aca debo controlar que esa persona no exista ya en las props.

    let per = _.find(this.props.contraventores, {
      persona: { _id: persona._id },
    });

    if (per) {
      //Esto significa que ya existia la persona y no debo volver a cargarla.

      notification.error({
        message: 'Persona Existente',
        description:
          'La persona que intento ingresar, ya existia en la autorizacion',
      });
      this.props.actionsMain.setCargaContraventor(
        !this.props.main.cargarContraventorToggle
      );
    } else {
      this.setState(
        {
          ...this.state,
          persona: {
            ...this.state.persona,
            ...persona,
          },
        },
        () => {
          this.siguientePaso();
        }
      );
    }
  };

  terminarCargaContraventor = nuevosDatos => {
    // this.props.history.push('agregarPersona/')
    let nuevaPersona = this.state.persona;
    delete nuevaPersona.__typename;
    delete nuevaPersona.fecha_ultimo_cambio;
    nuevaPersona.localidad = nuevaPersona.localidad
      ? nuevaPersona.localidad._id
      : '';
    this.props
      .agregarContraventor({
        variables: {
          _id: this.props.expediente._id,
          objContraventor: {
            estado: 'PRESUNTO CONTRAVENTOR',
            direccion_real: nuevosDatos,
            persona: nuevaPersona,
          },
        },
      })
      .then(respuesta => {
        // console.log('La respuesta es....');
        // console.log(respuesta);

        if (respuesta.data.agregarContraventor) {
          //Actualizar REDUX
          this.props.actionsContraventores.agregarContraventores(
            respuesta.data.agregarContraventor.contraventores
          );
          this.props.actionsMain.setCargaContraventor(
            !this.props.main.cargarContraventorToggle
          );
        }
      })
      .catch(err => {
        console.log('Existio un error en la consulta graphql');
        console.log(err);
      });

    // //REDIRIGIR
    // this.props.history.goBack();
  };

  onCancel = () => {
    this.props.actionsMain.setCargaContraventor(
      !this.props.main.cargarContraventorToggle
    );
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    const { Step } = Steps;
    let { step } = this.state;
    return (
      <div>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Sumar Contraventor
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Buscar Persona" />
            <Step title="Cargar Direccion Real" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona
                obtenerPersona={this.guardarPersona}
                onCancel={this.onCancel}
              />
            )}
            {step === 1 && (
              <FormDireccionReal
                onSubmit={this.terminarCargaContraventor}
                datos={this.state.persona}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsContraventores: bindActionCreators(actionsContraventores, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(SumarContraventor));
